import Form from 'antd/lib/form';
import React, { useContext, useState } from 'react';
import { Icon, Checkbox } from 'antd';
import { render } from 'react-dom';
import { GenericButton } from '../../fields/GenericButton';
import { ApplicationActionsContext } from '../../data/ApplicationDataSource';
import {FormValidationContext} from "../../../context/FormValidationProvider";

export function RecalculateButton({ value, defaultValue, ...props }) {
  const { isValid } = useContext(FormValidationContext);
  const actions = useContext(ApplicationActionsContext);
  return (
    <GenericButton
      icon='redo'
      label='Recalculate'
      onClick={() => actions.saveApplication()}
      type='primary'
      disabled={!isValid}
    />
  );
}
